import Header from './header'
import WpHeader from './wp-header'
import Footer from './footer'
import NotFound from './not-found'

export default {
    Header,
    WpHeader,
    Footer,
    NotFound,
}
